module.exports = __webpack_public_path__ + "static/media/GiantLanternEXTA0003_design_clean_v002.0df3a2d8.png";